"use strict";
// @ts-nocheck
exports.__esModule = true;
var matchesEntityType = function (type) { return type === "LINK"; };
var linkStrategy = function (contentBlock, cb, contentState, onClick) {
    if (!contentState) {
        return;
    }
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            matchesEntityType(contentState.getEntity(entityKey).getType()));
    }, cb);
};
exports["default"] = linkStrategy;
